module.exports = __webpack_public_path__ + "img/Victoria-Ortiz.ac1d05a5.jpg";